module.exports = __webpack_public_path__ + "static/media/girl-pinning.38f82a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intros/girl-pinning.png
// module id = 965
// module chunks = 0